import LangJs from 'lang.js';
import messages from '@js/plugins/strings.js';

const lang = new LangJs({ messages });
lang.setLocale(document.documentElement.lang);
lang.setFallback('en');

export default lang;
export const choice = (key, number, replacements, locale) =>
    lang.choice(key, number, replacements, locale);
export const trans = (key, replacement) => lang.trans(key, replacement);
